export interface PurchaseOrderLookup {
  po_no: string;
  rack: string | null;
  shelf: string | null;
  bin: string | null;
  dept_id: string | null;
  department: string | null;
  count_items_warning: boolean;
  vendor_id: string | null;
  vendor_name: string | null;
  warehouse_name: string | null;
  assigned_location: string;
  staging_note: string | null;
  job_id: string | null;
  job_desc: string | null;
  job_bay: string | null;
  // Present only for the staging-bay departments (Costco/Install) whose job has a bay.
  job_bay_banner: string | null;
}

// A TUDI PO is 5 or 6 bare digits, or R followed by 4-5 digits
// (mirrors Warehouse::Receiving::PoNumberExtractor::PO_FORMAT).
export const PO_NUMBER_FORMAT = /^(?:\d{5,6}|R\d{4,5})$/i;

// The backend caps a single scan at this many pages; the disabled button is the courtesy,
// the 422 is the guard.
export const MAX_SCAN_PAGES = 5;

export interface PoCandidate {
  value: string;
  label_on_document: string;
}

export interface PhotoScanResult {
  id: number;
  po_number: string | null;
  po_number_source: string | null;
  confidence: 'high' | 'medium' | 'low' | 'none';
  document_type: string;
  vendor_name: string | null;
  candidates: PoCandidate[];
  notes: string | null;
  line_items: ReceivingLineItem[];
}

export interface ReceivingLineItem {
  id?: number;
  description: string;
  // Rails serialises a decimal column as a string ("3.0"). Null when the document showed none.
  quantity: string | number | null;
  position?: number;
}

export interface ReceivingDetail {
  id: number | null;
  po_number: string | null;
  po_number_source: string | null;
  confidence: 'high' | 'medium' | 'low' | 'none' | null;
  document_type: string | null;
  vendor_name: string | null;
  extracted_line_items: unknown[];
  submitted_at: string | null;
  warehouse_wh_id: string | null;
  received_count: number | null;
  // Null until the receiving is submitted, and also when the stitch failed.
  receipt_pdf_url: string | null;
  line_items: ReceivingLineItem[];
  media: ReceivingMedia[];
}

export interface ReceivingMedia {
  id: number;
  kind: 'document' | 'equipment';
  filename: string;
  content_type: string | null;
  url: string;
}
